"use client";

import Image from "next/image";
import profile1 from '@/public/clientProfile/profile1.jpg'
import profile2 from '@/public/clientProfile/profile2.jpg'
import profile3 from '@/public/clientProfile/profile3.jpg'
import profile4 from '@/public/clientProfile/profile4.jpg'
import profile5 from '@/public/clientProfile/profile5.jpg'
import profile6 from '@/public/clientProfile/profile6.jpeg'
import profile7 from '@/public/clientProfile/profile7.jpg'
import React, { useEffect, useState } from "react";
import { InfiniteMovingCards } from "@/components/ui/infinite-moving-cards";

export default function Testimonials() {
    const testimonials = [
        {
            name: "Pratik Gupta",
            role: "Gold medalist - Natural Bodybuilding",
            text: "I recently installed a solar power system from Solar Enterprises, and I have to say, I’m genuinely impressed with the quality and performance. The installation team was professional, efficient, and explained everything clearly. My electricity bills have dropped significantly, and I love knowing I’m contributing to a greener planet.",
            profile: profile1
            //   img: "/user1.jpg",
        },
        {
            name: "Savanna Muse",
            role: "International Medalist in Rowing",
            text: "I recently made a purchase from Solar Enterprises, and I’m extremely satisfied with their service. From the initial consultation to the final installation, everything was handled professionally. The team helped me understand the benefits of solar energy and designed a system that perfectly fits my home’s needs.",
            profile: profile2
        },
        {
            name: "Riyan Das",
            role: "Fitness Influencer",
            text: "After researching several solar companies, I chose Solar Enterprises — and I couldn’t be happier. Their commitment to quality and customer satisfaction truly stands out. The solar panels they installed are performing exceptionally well, and I’m seeing noticeable savings on my monthly bills.",
            profile: profile3
        },
        {
            name: "Kiran Malhotra",
            role: "Athlete",
            text: "I recently partnered with Solar Enterprises to install solar panels at my residence, and the experience was exceptional. The entire process, from inquiry to installation, was smooth and transparent. Their engineers were knowledgeable and helped me choose the best system for my power needs.",
            profile: profile4
        },
        {
            name: "Devansh Kapoor",
            role: "Yoga Instructor",
            text: "I decided to invest in solar energy to reduce my carbon footprint, and Solar Enterprises made it simple and rewarding. Their products are top-notch, and their installation team is highly skilled. Within a few weeks of switching to solar, I noticed a clear reduction in my electricity bills.",
            profile: profile5
        },
        {
            name: "Arjun Mehta",
            role: "Cyclist",
            text: "Working with Solar Enterprises has been one of the best decisions I’ve made for my home. Their solar panels are efficient, stylish, and built to last. The technicians were well-trained and ensured everything was set up perfectly. They also provided detailed insights into optimizing power usage.",
            profile: profile6,
        },
        {
            name: "Neel Verma",
            role: "Nutritionist",
            text: "I recently made a purchase from Solar Enterprises, and it has been an outstanding experience. The quality of their solar products exceeded my expectations, and the energy output has been consistently reliable. The team took time to evaluate my requirements, designed an efficient system",
            profile: profile7
        },
    ];

    return (
        <div className="w-full xl:min-h-[26.9rem] 2xl:min-h-[26.9rem] xl:px-16 2xl:px-18 md:px-8 px-4 bg-gray-50 flex">
            <div className="w-full">
                <h2 className="text-3xl font-bold text-left mb-10">
                    What customers say
                </h2>
                <div className="rounded-md flex flex-col antialiased dark:bg-black dark:bg-grid-white/[0.05] items-center justify-center relative overflow-hidden">
                    <InfiniteMovingCards
                        items={testimonials}
                        direction="right"
                        speed="normal"
                    />
                </div>
            </div>
        </div>
    );
}
